import { Injectable } from '@angular/core';
import { filter, Observable, switchMap, take } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { AppState } from '@store/reducers';
import { IResponseSuccess } from '@core/interfaces';
import { selectDualPricingList, selectStore } from '@store/selectors';
import { DualPricing, Store as StoreModel } from '@core/models';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DualPricingService {
  dualPricingList$: Observable<DualPricing[] | null>;
  store$: Observable<StoreModel | null>;

  constructor(
    private http: HttpClient,
    private store: Store<AppState>,
  ) {
    this.dualPricingList$ = this.store.select(selectDualPricingList);
    this.store$ = this.store.select(selectStore)
  }

  find(id: string): Observable<IResponseSuccess<DualPricing>> {
    return this.store$.pipe(
      filter((store) => !!store),
      switchMap((store) => {
        return this.http.get<IResponseSuccess<DualPricing>>(
          `${environment.microConfiguraciones}/doble-precio/${id}`,
          {
            headers: {
              authorization: store.apiKey,
            }
          },
        );
      }),
      take(1),
    );
  }

  findAll(): Observable<IResponseSuccess<DualPricing>> {
    return this.store$.pipe(
      filter((store) => !!store),
      switchMap((store) => {
        return this.http.get<IResponseSuccess<DualPricing>>(
          `${environment.microConfiguraciones}/dualPricings`,
          {
            params: {
              localId: store.idLocal,
            },
            headers: {
              authorization: store.apiKey,
            }
          },
        );
      }),
      take(1),
    );
  }

}
